export function getTenantFromUrl(): string | null {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (parts && parts.length === 4 && parts[1]?.includes("forms") && parts[2] === "agridence") {
    return parts[0]!.toLowerCase();
  }

  return null;
}

export function matchUrl(urlToMatch: string, basePaths: string[]) {
  return basePaths.some((basePath) => new RegExp(`^${basePath}/.*$`).test(urlToMatch) || basePath === urlToMatch);
}
